import Vue from 'vue'
// @ts-ignore
import App from './App.vue'
import router from './router'
import './utils/flexible'
import './assets/reset.css'
import store from './store'
import api from './server/api/index.js'
// import utils from './utils/map'
// import { Drawer } from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
// Vue.use(Drawer)
import { Popup, Collapse, CollapseItem, Icon, Toast } from 'vant'
import 'vant/lib/popup/style'
import 'vant/lib/collapse/style'
import 'vant/lib/collapse-item/style'
import 'vant/lib/icon/style'
import 'vant/lib/toast/style'
import Clipboard from 'vue-clipboard2'

// @ts-ignore
Vue.use(Clipboard)

Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Icon)
Vue.use(Popup)
Vue.use(Toast)
Vue.prototype.$api = api
Vue.prototype.$toast = Toast
Vue.config.productionTip = false
// Vue.prototype.$utils = utils
new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
